<style>
  .content {
    tui-tile._dragged & {
      box-shadow: var(--tui-shadow-small-hover);
    }
  }
</style>

@let tableColumns = $tableColumns();

@if (tableColumns) {
  <button
    tuiButton
    [tuiDropdown]="editTableDropdown"
    [tuiDropdownManual]="$open()"
    (click)="toggle()"
    (tuiActiveZoneChange)="onActiveZone($event)"
    type="button"
    iconEnd="@tui.chevron-down"
    appearance="outline"
    size="s"
    class="h-9! bg-(--tui-background-base)! w-[200px]"
  >
    <span class="x-text-dark-main x-font-body-5-bold"> Редактировать вид </span>
  </button>
}

<ng-template #editTableDropdown>
  <!--  Настройки строк -->
  <div class="flex justify-center items-center px-4 x-font-body-4-bold mt-2">
    {{ 'requests_list.rows_settings_title' | translate }}
  </div>
  <div class="grid auto-rows-[minmax(36px,auto)]">
    @for (rowSettingsItem of rowSettingsArray; track $index) {
      <div
        class="flex justify-between h-full items-center px-4 border-b border-b-(--tui-background-neutral-1-hover)"
      >
        <label class="x-font-body-5-bold flex items-center grow">
          <input
            tuiCheckbox
            type="checkbox"
            size="m"
            class="me-2! shrink-0"
            [(ngModel)]="rowSettingsItem.value"
            (ngModelChange)="rowSettingsChange()"
          />
          {{ 'requests_list.rows_settings.' + rowSettingsItem.key | translate }}
        </label>
      </div>
    }
  </div>

  <!--  Настройки колонок -->
  <div
    class="flex justify-center items-center px-4 x-font-body-4-bold mt-4"
    #columnsSettings
    tabindex="0"
  >
    {{ 'requests_list.columns_settings_title' | translate }}
  </div>
  <tui-tiles
    [(order)]="colsOrder"
    xTilesOrder
    class="auto-rows-[minmax(36px,auto)] w-[200px]"
    (orderChangeFinished)="onColumnsOrderChange($event)"
    [debounce]="0"
  >
    @for (col of initialColumns; track col; let index = $index) {
      <tui-tile [style.order]="colsOrder.get(index)">
        <div
          class="content h-full flex justify-between items-center px-4 border-b border-b-(--tui-background-neutral-1-hover)"
        >
          <label class="h-full x-font-body-5-bold flex items-center grow">
            <input
              tuiCheckbox
              type="checkbox"
              size="m"
              class="me-2! shrink-0"
              [(ngModel)]="this.columnsChecked[col]"
              (ngModelChange)="ratingCheckedChange(col, $event)"
            />
            {{ 'requests_list.columns.' + col | translate }}
          </label>
          <tui-icon
            icon="@tui.grip-vertical"
            tuiTileHandle
            class="cursor-ns-resize text-[1rem]!"
          />
        </div>
      </tui-tile>
    }
  </tui-tiles>
  <hr />
  <div class="text-center py-2 px-4">
    <button
      tuiButton
      appearance="outline"
      size="s"
      class="w-full complete-button h-[28px]! x-font-body-5-bold"
      (click)="resetTableSettings()"
    >
      {{ 'requests_list.reset' | translate }}
    </button>
  </div>
</ng-template>
